<template>
  <b-modal
      centered
      no-close-on-backdrop
      no-close-on-esc
      v-model="modelCommodityShow"
      no-stacking
      hide-footer
  >
    <template slot="modal-header">
      <div slot="header" class="bg-white border-0">
        <div class="row align-items-center">
          <div class="col-12">
            <h3 class="mb-0">
              请选择商品数量
            </h3>
          </div>
        </div>
      </div>
    </template>
    <card shadow type="secondary" class="m--4">
      <template>
        <div>
          <div class="row">
            <div class="col-md-12">
              <el-image :src="commodityInfo.picUrl" style="height: 200px;width:auto;"></el-image>
              <h3 style="font-size: 18px;font-weight: bold" class="font-weight-700">{{commodityInfo.spuName}} - {{commodityInfo.retailPrice}} บาท</h3>
              <el-input-number v-model="count" @change="changeCount" :min="1" label="请输入"></el-input-number>
            </div>
          </div>
        </div>
      </template>
    </card>
    <div class="mt-5 w-100 text-right">
      <b-button
          variant="secondary"
          class="mx-3"
          @click="closeModel()"
      >
        ยกเลิก
      </b-button>
      <b-button
          type="submit"
          class="w-25"
          variant="success"
          @click="confirmCommodity()"
      >ยืนยัน</b-button>
    </div>
  </b-modal>
</template>
<script>
import {createCommodity, editCommodityOrder} from "@/api/express";

export default {
  props:{
    commodityInfo:{
      type:Object,
      default:() => {}
    }
  },
  data(){
    return {
      modelCommodityShow:false,
      count:0,
      isEdit:1,
      editCommodityData:{}
    }
  },
  methods:{
    showCommodityModel(item,type){
      console.log(item,type)
      this.isEdit = type
      if (type === 1){
        this.modelCommodityShow = true
      }else{
        this.count = item.salesCount
        this.editCommodityData = item
        this.modelCommodityShow = true
      }
    },
    closeModel(){
      this.modelCommodityShow = false
    },
    changeCount(){

    },
    confirmCommodity(){
      if (this.isEdit === 1){
        let params = {
          skus:[{
            skuId: this.commodityInfo.skuId,
            count: this.count
          }],
          cashNum:this.$store.state.cashNum
        }
        createCommodity(params)
            .then((res) => {
              this.closeModel()
              this.$emit('fnGetPosRecentlyList')
              this.$message({
                type:"success",
                message:'添加商品成功'
              })
            })
      }else{
        let param = {
          id: this.editCommodityData.id,
          salesCount: this.count
        }
        editCommodityOrder(param)
            .then((res) => {
              this.closeModel()
              this.$emit('fnGetPosRecentlyList')
              this.$message({
                type:"success",
                message:'编辑商品成功'
              })
            })
      }
    },
  }
}
</script>
